import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { globals, UserBadLoginAttempt } from '../../globals';
import { LoginErrorsComponent } from './login-errors/login-errors.component';

@Component({
  selector: 'ez-login-form',
  imports: [
    CommonModule,
    LoginErrorsComponent,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatDividerModule,
  ],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginFormComponent implements OnInit {
  returnUrl: string = '';
  overrideSessions: string = '';
  forgotPasswordUrl: string = '';
  continueUrl: string = '';
  isLoggedIn: string = '';
  isAutomationUser: boolean;
  legacyLoginUrl: string = '';
  lastSsoProvider: string | null = null;
  challengeUrl: string | null = null;

  badLogInAttempt: UserBadLoginAttempt | null = null;

  // These two are just to provide validators for the inputs.
  readonly #fb = inject(FormBuilder);
  form;

  constructor(elementRef: ElementRef) {
    const getAttribute = elementRef.nativeElement.getAttribute.bind(elementRef.nativeElement);

    this.returnUrl = getAttribute('return-url');
    this.overrideSessions = getAttribute('override-sessions');
    this.forgotPasswordUrl = getAttribute('forgot-password-url');
    this.continueUrl = getAttribute('continue-url');
    this.isLoggedIn = getAttribute('is-logged-in');
    this.isAutomationUser = getAttribute('is-automation-user') ? true : false;
    this.legacyLoginUrl = getAttribute('legacy-login-url');

    this.form = this.#fb.group({
      returnUrl: [this.returnUrl],
      overrideSessions: [this.overrideSessions ? 'True' : 'False'],
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.badLogInAttempt = globals.badLogInAttempt;
    this.lastSsoProvider = localStorage.getItem('lastSsoProvider');
    const challengeUrl = localStorage.getItem('challengeUrl');

    // grab query string parameter from urls
    const urlParams = new URLSearchParams(window.location.search);
    const redirectUrl = urlParams.get('redirectURL');
    this.challengeUrl = `${challengeUrl}?returnUrl=${redirectUrl}`;
  }

  clearSsoLocalStorageVariables(): void {
    localStorage.removeItem('lastSsoProvider');
    localStorage.removeItem('challengeUrl');
  }
}
